import { Badge, Group } from '@mantine/core';
import { useTranslation } from 'locales';
import { MAIL_CATEGORY_COLORS, MAIL_CATEGORY_LABELS, type MailCategory } from 'modules/Mails/types';
import { CategoryDot } from './CategoryDot';

type CollapsedCategoryChipsProps = {
  categories: ReadonlyArray<MailCategory>;
};

const COLLAPSED_VISIBLE_CATEGORIES = 2;

export const CollapsedCategoryChips = ({ categories }: CollapsedCategoryChipsProps) => {
  const { t } = useTranslation();
  const visible = categories.slice(0, COLLAPSED_VISIBLE_CATEGORIES);
  const overflow = categories.length - visible.length;
  return (
    <Group gap={4} wrap="nowrap" style={{ flexShrink: 0 }}>
      {visible.map(category => (
        <Badge
          key={category}
          variant="light"
          size="xs"
          color={MAIL_CATEGORY_COLORS[category]}
          leftSection={<CategoryDot color={MAIL_CATEGORY_COLORS[category]} />}
        >
          {t(MAIL_CATEGORY_LABELS[category])}
        </Badge>
      ))}
      {overflow > 0 && (
        <Badge variant="light" size="xs" color="gray">
          +{overflow}
        </Badge>
      )}
    </Group>
  );
};
